var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ja from 'date-fns/locale/ja';
import { useState } from 'react';
import DatePicker, { registerLocale, } from 'react-datepicker';
import { datePickerFieldStyle } from '@/components/ui/Form/DatePickerField/style';
import { formatToString } from '@/utils/libs/date-fns/format';
registerLocale('ja', ja);
/**
 * 日付入力 Field
 */
export const DatePickerFieldBase = (props) => {
    const { className, dateFormat: propDateFormat, input, isError: propIsError, maxDate, meta, minDate, popperPlacement = 'bottom-start', showTimeSelect } = props, datePickerProps = __rest(props, ["className", "dateFormat", "input", "isError", "maxDate", "meta", "minDate", "popperPlacement", "showTimeSelect"]);
    const { name, onChange: inputOnChange, value } = input, restInput = __rest(input, ["name", "onChange", "value"]);
    const { dirtySinceLastSubmit, error, submitError, touched } = meta;
    const dateFormat = propDateFormat ||
        (showTimeSelect ? 'yyyy年MM月dd日 HH:mm' : 'yyyy年MM月dd日');
    const isError = propIsError ||
        (((submitError && !dirtySinceLastSubmit) || error) && touched);
    const [startDate, setStartDate] = useState(input.value);
    const style = datePickerFieldStyle();
    return (_jsx(DatePicker, Object.assign({}, restInput, { ariaInvalid: `${isError}`, autoComplete: 'off', className: style.base({ class: className }), dateFormat: dateFormat, locale: 'ja', minDate: minDate, name: name, onChange: (date) => {
            if (!date)
                return;
            const min = minDate ? new Date(minDate) : null;
            const max = maxDate ? new Date(maxDate) : null;
            const selected = new Date(date);
            // 最小日付より前の日付が選択された場合は最小日付をセット
            if (min && selected < min) {
                setStartDate(min);
                inputOnChange(min);
                return;
            }
            // 最大日付より後の日付が選択された場合は最大日付をセット
            if (max && max < selected) {
                setStartDate(max);
                inputOnChange(max);
                return;
            }
            // それ以外の場合は選択された日付をセット
            setStartDate(date);
            inputOnChange(date);
        }, popperPlacement: popperPlacement, selected: startDate, showTimeSelect: showTimeSelect, value: value && value instanceof Date
            ? formatToString({ formatString: dateFormat, value })
            : value || '' }, datePickerProps)));
};
